export default function SectionHeader({title,no,colorClass = 'text-primary-dark'}){
    return <div className={colorClass + ' text-size-16 mb-3'}>{no +'.'+ title}</div>;
}